<template lang="pug">
  v-card.mx-auto(
    max-width="1200"
    flat
    color="transparent"
  )
    v-card.mx-auto(
      max-width="1200"
      flat
      color="transparent"
    )
      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          DatePicker(v-model="dateModel")

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Название мероприятия"
            full-width
            v-model="nameModel"
          )

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Код мероприятия из 1С"
            full-width
            v-model="codeModel"
          )

</template>

<script>

import DatePicker from './DatePicker'

export default {
  components: {
    DatePicker
  },
  props: {
    name: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
    code: {
      type: String,
      default: null,
    },
  },
  computed: {
    nameModel: {
      get() {
        return this.name
      },

      set(val) {
        this.$emit('nameChanged', val)
      },
    },
    dateModel: {
      get() {
        return this.date
      },

      set(val) {
        this.$emit('dateChanged', val)
      },
    },
    codeModel: {
      get() {
        return this.code
      },

      set(val) {
        this.$emit('codeChanged', val)
      },
    },
  },

}
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 400px;
}
</style>
